"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractNavLinks = void 0;
var content_page_1 = require("./content-page");
var diagnostic_1 = require("./diagnostic");
var invoices_1 = require("./invoices");
var landing_1 = require("./landing");
var login_1 = require("./login");
var menu_item_1 = require("./menu-item");
var notifications_1 = require("./notifications");
var pre_ticket_chat_1 = require("./pre-ticket-chat");
var quotes_1 = require("./quotes");
var redirect_1 = require("./redirect");
var request_type_1 = require("./request-type");
var request_types_1 = require("./request-types");
var support_options_1 = require("./support-options");
var survey_1 = require("./survey");
var ticket_1 = require("./ticket");
var ticket_list_1 = require("./ticket-list");
__exportStar(require("./auth-link"), exports);
__exportStar(require("./oauth-link"), exports);
exports.extractNavLinks = new Map([
    ['redirect', redirect_1.extractRedirect],
    ['landing_page', landing_1.extractLanding],
    ['menu_item', menu_item_1.extractMenuItem],
    ['ticket', ticket_1.extractTicket],
    ['ticket_list', ticket_list_1.extractTicketList],
    ['content_page', content_page_1.extractContentPage],
    ['support_options', support_options_1.extractSupportOptions],
    ['pre_ticket_chat', pre_ticket_chat_1.extractPreTicketChat],
    ['request_types', request_types_1.extractRequestSupport],
    ['request_type', request_type_1.extractRequestType],
    ['invoices', invoices_1.extractInvoices],
    ['invoice', invoices_1.extractInvoice],
    ['quotes', quotes_1.extractQuotes],
    ['quote', quotes_1.extractQuote],
    ['diagnostic', diagnostic_1.extractDiagnostic],
    ['notifications', notifications_1.extractNotifications],
    ['login', login_1.extractLogin],
    ['survey', survey_1.extractSurvey],
]);
